import React, { useEffect } from "react";
import "./MusicPage.css";

// =====================================================
// COMPOSANT REACT PRINCIPAL
// =====================================================

function MusicPage() {

  useEffect(() => {
    if (window.initMusicPlayer) {
      window.initMusicPlayer();
    }
  }, []);

  return (
    <div className="music-page">

      {/* BACKGROUND */}
      <div id="backgroundGradient"></div>
      <div id="backgroundGradientTransition"></div>

      {/* PLAYER */}
      <div id="player">

        {/* VINYL */}
        <div id="vinyl">
          <div id="disc" className="rotateDisc"></div>
        </div>

        {/* COVER */}
        <div id="cover" className="show0">
          <img id="album" alt="" />
        </div>

        {/* PLAYLIST (flip) */}
        <div id="playlist"></div>

        {/* TIMER */}
        <svg id="timer" width="120" height="120">
          <circle
            id="total-timer"
            cx="60"
            cy="60"
            r="52"
            stroke="#ccc"
            strokeWidth="4"
            fill="none"
          />
          <circle
            id="timer-dash"
            cx="60"
            cy="60"
            r="52"
            stroke="#333"
            strokeWidth="4"
            fill="none"
            strokeDasharray="0 49"
          />
        </svg>

        {/* INFOS */}
        <div id="infos">
          <div id="title"></div>
          <div id="artist"></div>
        </div>

        {/* BUTTONS */}
        <div id="buttons">

          <div className="previous">
            <p>&lt;&lt;</p>
          </div>

          <div id="playPause">
            <p>&rtrif;</p>
          </div>

          <div className="next">
            <p>&gt;&gt;</p>
          </div>

          {/* <label id="playlistLink">≡</label> */}

          <div id="volume">
            <input type="checkbox" />
            <input
              id="volumeSlider"
              type="range"
              min="0"
              max="100"
              defaultValue="50"
            />
          </div>

        </div>

        {/* AUDIOS */}
        <audio id="audio0" src="/musics/misses.mp3"></audio>
        <audio id="audio1" src="/musics/walkaway.mp3"></audio>
        <audio id="audio2" src="/musics/guardian.mp3"></audio>

      </div>
    </div>
  );
}

export default MusicPage;

// =====================================================
// SCRIPT MUSIQUE ORIGINAL (CORRIGÉ DOM UNIQUEMENT)
// =====================================================

export function initMusicPlayer() {

  const songs = [
    {
      title: "Misses",
      artist: "Girls in Hawaii",
      cover: "",
      num: 0,
      darkColor: "#3A4E55",
      lightColor: "#F2F2F2"
    },
    {
      title: "Walk Away From The Sun",
      artist: "Seether",
      cover: "",
      num: 1,
      darkColor: "#4B3A40",
      lightColor: "#E0D9C6"
    },
    {
      title: "The Fifth Guardian, Interlude",
      artist: "Epica",
      cover: "",
      num: 2,
      darkColor: "#231F16",
      lightColor: "#FFF8E8"
    }
  ];

  const playlist = document.getElementById("playlist");
  const album = document.getElementById("album");
  const title = document.getElementById("title");
  const artist = document.getElementById("artist");
  const playPause = document.getElementById("playPause");
  const disc = document.getElementById("disc");
  const vinyl = document.getElementById("vinyl");
  const cover = document.getElementById("cover");
  const timerDash = document.getElementById("timer-dash");
  const bg = document.getElementById("backgroundGradient");
  const bgTransition = document.getElementById("backgroundGradientTransition");
  const volumeSlider = document.getElementById("volumeSlider");

  if (
    !playlist || !album || !title || !artist || !playPause ||
    !disc || !vinyl || !cover || !bg || !bgTransition
  ) {
    console.error("MusicPlayer DOM not ready");
    return;
  }

  let currentSong = 0;
  let audio = null;
  let timer = null;
  const dashLength = 49;

  playlist.innerHTML = "";

  songs.forEach(song => {
    const p = document.createElement("p");
    p.innerHTML = `${song.title} &#183; ${song.artist}`;
    playlist.appendChild(p);
  });

  playlist.children[0].classList.add("active");
  disc.classList.add("rotateDisc");

  loadSong(1);
  pause();

  playlist.onclick = (e) => {
    if (e.target.tagName === "P") {
      loadSong([...playlist.children].indexOf(e.target));
      hidePlaylist();
    }
  };

  playPause.onclick = () => {
    if (!audio) return;
    audio.paused ? play() : pause();
  };

  const prev = document.querySelector(".previous");
  const next = document.querySelector(".next");

  if (prev) prev.onclick = () => nextSong(-1);
  if (next) next.onclick = () => nextSong(1);

  if (volumeSlider) {
    volumeSlider.oninput = () => {
      if (audio) audio.volume = volumeSlider.value / 100;
    };
  }

  function loadSong(index) {
    currentSong = index;
    if (audio) audio.pause();

    audio = document.getElementById(`audio${index}`);
    if (!audio) return;

    if (volumeSlider) audio.volume = volumeSlider.value / 100;

    album.src = songs[index].cover || "";
    title.textContent = songs[index].title;
    artist.textContent = songs[index].artist;
    artist.style.color = songs[index].darkColor;

    [...playlist.children].forEach(p => p.classList.remove("active"));
    playlist.children[index].classList.add("active");

    changeBackground();
    play(0);
  }

  function play(start = null) {
    animateVinyl("50%");
    if (start !== null) audio.currentTime = start;
    audio.play();

    const p = playPause.querySelector("p");
    if (p) {
      p.innerHTML = "&#61;";
      p.style.transform = "rotate(90deg) scale(1,1.5)";
    }

    if (timer) clearInterval(timer);
    timer = setInterval(updateTime, 1000);

    audio.onended = () => {
      pause();
      nextSong(1);
    };
  }

  function pause() {
    animateVinyl(0);
    if (audio) audio.pause();

    const p = playPause.querySelector("p");
    if (p) {
      p.innerHTML = "&rtrif;";
      p.style.transform = "rotate(0deg) scale(1,1.5)";
    }

    if (timer) clearInterval(timer);
    timer = null;
  }

  function nextSong(dir) {
    currentSong = (currentSong + dir + songs.length) % songs.length;
    loadSong(currentSong);
  }

  function animateVinyl(left) {
    vinyl.style.left = left;
  }

  function updateTime() {
    if (!audio || !timerDash) return;
    const ratio = dashLength * audio.currentTime / audio.duration;
    timerDash.style.strokeDasharray = `${ratio} ${dashLength - ratio}`;
  }

  function changeBackground() {
    bgTransition.style.background =
      `radial-gradient(${songs[currentSong].lightColor}, ${songs[currentSong].darkColor})`;
    bg.style.opacity = "0";

    setTimeout(() => {
      bg.style.background = bgTransition.style.background;
      bg.style.opacity = "1";
    }, 500);
  }

  function showPlaylist() {
    animateVinyl(0);
    cover.classList.add("show90");
    playlist.classList.add("show0");
  }

  function hidePlaylist() {
    playlist.classList.remove("show0");
    cover.classList.remove("show90");
    if (audio && !audio.paused) animateVinyl("50%");
  }
}

// EXPOSE POUR REACT
window.initMusicPlayer = initMusicPlayer;
